module.exports = {
  name: 'DeviceStatus',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasStatus() {
      return this.isOffline || this.isBatteryLow;
    },
    displayStatusIcon() {
      if(this.isOffline) return 'cloud_off';
      if(this.isBatteryLow) return 'battery_full';
    },
    displayStatusText() {
      if(this.isOffline) return 'device.offline';
      if(this.isBatteryLow) return 'device.battery_low';
    },
    isOffline() {
      return new Date().getTime() - this.item.lastUpdateTimestamp * 1000 > 24 * 60 * 60 * 1000;
    },
    isBatteryLow() {
      return this.item.battery <= 20 && this.item.battery > 0;
    }
  },
  template: `
<v-list-tile-action v-if="hasStatus">
  <v-tooltip left>
    <v-icon slot="activator" color="red">{{ displayStatusIcon }}</v-icon>
    <span>{{ $t(displayStatusText) }}</span>
  </v-tooltip>
</v-list-tile-action>
  `
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/DeviceStatus.js
// module id = YX7K
// module chunks = 0